import { render, staticRenderFns } from "./usage.vue?vue&type=template&id=2625d7d0"
import script from "./usage.vue?vue&type=script&lang=js"
export * from "./usage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2625d7d0')) {
      api.createRecord('2625d7d0', component.options)
    } else {
      api.reload('2625d7d0', component.options)
    }
    module.hot.accept("./usage.vue?vue&type=template&id=2625d7d0", function () {
      api.rerender('2625d7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicconfig/usage.vue"
export default component.exports